import React, { createContext, useContext, useState, useCallback } from 'react';

const UnsavedChangesContext = createContext();

export const UnsavedChangesProvider = ({ children }) => {
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
    const [lastSaveTime, setLastSaveTime] = useState(null);

    // Marca que há mudanças não salvas
    const markAsChanged = useCallback(() => {
        setHasUnsavedChanges(true);
    }, []);

    // Marca que as mudanças foram salvas
    const markAsSaved = useCallback(() => {
        setHasUnsavedChanges(false);
        setLastSaveTime(new Date());
    }, []);

    // Verifica se há mudanças não salvas
    const checkUnsavedChanges = useCallback(() => {
        return hasUnsavedChanges;
    }, [hasUnsavedChanges]);

    const value = {
        hasUnsavedChanges,
        lastSaveTime,
        markAsChanged,
        markAsSaved,
        checkUnsavedChanges
    };

    return (
        <UnsavedChangesContext.Provider value={value}>
            {children}
        </UnsavedChangesContext.Provider>
    );
};

export const useUnsavedChangesContext = () => {
    const context = useContext(UnsavedChangesContext);
    if (!context) {
        throw new Error('useUnsavedChangesContext deve ser usado dentro de um UnsavedChangesProvider');
    }
    return context;
};
